import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidateSocialGraph } from "Api/Mutations/Social/invalidateSocialGraph";
import { deleteSocialBlocksTargetIdentityUserPublicID } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Translations/Resources";
import { toast } from "sonner";

/**
 * Revokes the caller's block of a persona (idempotent). Severed follows
 * are NOT restored — the pair rebuilds explicitly.
 */
export const useUnblockUserMutation = () => {
  const queryClient = useQueryClient();
  const { t } = useResource();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (targetIdentityUserPublicID: string) =>
        deleteSocialBlocksTargetIdentityUserPublicID(
          targetIdentityUserPublicID,
        ),
    ),
    onSuccess: () => invalidateSocialGraph(queryClient),
    onError: () => toast.error(t(Resources.Errors.RequestError)),
  });
};
